import { put, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  actionLayoutErrorSet,
  actionModalOpen,
  actionSpinnerClose,
  actionSpinnerOpen,
} from '../actions';
import { getServerErrorMessage } from '../../utils';
import {
  SAGA_STATUS_BEGIN,
  SAGA_STATUS_ERROR,
  SAGA_STATUS_FINISH,
  SET_OTP,
} from '../actions/types';

const isDev = process.env.NODE_ENV === 'development';

export function* defaultSagaError(e) {
  yield put(actionLayoutErrorSet(getServerErrorMessage(e)));
  yield put(actionModalOpen('ModalError'));
}

export function createSaga(saga, { name, action, onError, onBegin, onFinish, take = 'every' }) {
  return function* () {
    const effect = take === 'every' ? takeEvery : takeLatest;
    yield effect(action, function* (...args) {
      // we check handleBadRequest to allow a single action to have default error handler
      // or handle the error by itself
      // TODO: handle if args has multiple elements
      const payload = args?.[0]?.payload;

      try {
        yield put({ type: SAGA_STATUS_BEGIN, payload: { name } });
        if (onBegin) yield onBegin(payload);
        yield saga(...args);
      } catch (e) {
        if (onError) {
          // eslint-disable-next-line no-console
          if (isDev) console.error(e);
          yield onError(e, payload);
        }
        yield put({
          type: SAGA_STATUS_ERROR,
          payload: { name, error: e.message || 'Unknown Error!', rawError: e },
        });
      } finally {
        if (onFinish) yield onFinish(payload);
        yield put({ type: SAGA_STATUS_FINISH, payload: { name } });
      }
    });
  };
}

export function createQadraSaga(
  saga,
  {
    name,
    action,
    take,
    onBegin,
    onErrorByStatus,
    onError,
    onFinish,
    hideSpinner,
    hideError,
    hideErrorByStatus,
  }
) {
  return createSaga(saga, {
    name,
    action,
    take,
    *onBegin(payload) {
      const actionHideSpinner = payload?.hideSpinner;
      if (!hideSpinner && !actionHideSpinner) yield put(actionSpinnerOpen());
      if (onBegin) yield onBegin();
    },
    *onError(e, payload) {
      if (hideErrorByStatus && hideErrorByStatus.includes(e.status)) {
        hideError = true;
      }

      if (onErrorByStatus && onErrorByStatus[e.status]) {
        // if we want to handle a bad request by ourself
        // we probably don't need the error layout
        hideError = true;

        yield onErrorByStatus[e.status](e, payload);
      } else if (onError) {
        yield onError(e, payload);
      }

      if (!hideError) yield defaultSagaError(e);
    },
    *onFinish(payload) {
      if (onFinish) yield onFinish();

      const actionHideSpinner = payload?.hideSpinner;
      if (!hideSpinner && !actionHideSpinner) yield put(actionSpinnerClose());
    },
  });
}

export function handleOtp(id) {
  function* handleError(e) {
    const payload = {
      id,
      message: e.errors.otp,
      code: e.errors.otpCode,
      alias: e.errors.alias,
    };
    yield put({ type: SET_OTP, payload });
  }
  return {
    onErrorByStatus: {
      400: handleError,
      503: handleError,
    },
  };
}
